const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class PaymentMethodServiceConnector {
  constructor(configuration) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);
  }

  async getClientSecret({ corporationId, paymentProviderName }) {
    assert(corporationId, 'expected corporationId');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/payment/methods/corporations/${corporationId}`, { paymentProviderName });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async storeCard({ id, corporationId, paymentProviderName }) {
    assert(corporationId, 'expected corporationId');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/payment/methods/${id}/corporations/${corporationId}`, { paymentProviderName });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async list({ corporationId, employeeGroupId, paymentProviderName }) {
    assert(corporationId, 'expected corporationId');
    try {
      const { data } = await this.httpClient.get(
        `/${CURRENT_VERSION}/payment/methods/corporations/${corporationId}`,
        { params: { employeeGroupId, paymentProviderName } },
      );
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteCard({ id, corporationId, paymentProviderName }) {
    assert(corporationId, 'expected corporationId');
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/payment/methods/${id}/corporations/${corporationId}`, { data: { paymentProviderName } });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async managePaymentMethodEmployeeGroups({
    corporationId,
    paymentMethodId,
    addedEmployeeGroupIds,
    removedEmployeeGroupIds,
    paymentProviderName,
  }) {
    assert(corporationId, 'expected corporationId');
    assert(paymentMethodId, 'expected paymentMethodId');
    assert((addedEmployeeGroupIds || removedEmployeeGroupIds), 'expected addedEmployeeGroupIds or removedEmployeeGroupIds');

    const body = {};

    if (addedEmployeeGroupIds) {
      body.addedEmployeeGroupIds = addedEmployeeGroupIds;
    }
    if (removedEmployeeGroupIds) {
      body.removedEmployeeGroupIds = removedEmployeeGroupIds;
    }

    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/payment/methods/${paymentMethodId}/corporations/${corporationId}/employee-groups`, body, { params: { paymentProviderName } });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getEmployeeGroupsForPaymentMethodId({ corporationId, paymentMethodId, paymentProviderName }) {
    assert(corporationId, 'expected corporationId');
    assert(paymentMethodId, 'expected paymentMethodId');

    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/payment/methods/${paymentMethodId}/employee-groups`,
        { params: { paymentProviderName } });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  PaymentMethodServiceConnector,
};
